import { Spinner, YStack } from '@frontend/web-react';

export const CardModalSpinner = () => (
  <YStack alignItems="center" gap="md" justifyContent="center" p="xl">
    <Spinner />
  </YStack>
);
